import React, { useState } from 'react';
import { formatDate } from '../../utils/dates';

const Timeline: React.FC<{ startDate: string; endDate: string }> = ({ startDate, endDate }) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const today = new Date();

  const totalDuration = end.getTime() - start.getTime();
  const elapsed = today.getTime() - start.getTime();
  const progressPercent = Math.min(Math.max((elapsed / totalDuration) * 100, 0), 100);

  const [hovered, setHovered] = useState(false);

  return (
    <div className="timeline-container">
      <div className="timeline-labels">
        <span className="timeline-date">{formatDate(start)}</span>
        <span className="timeline-date today">Today: {formatDate(today)}</span>
        <span className="timeline-date">{formatDate(end)}</span>
      </div>
      <div
        className="timeline-bar"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className="timeline-progress" style={{ width: `${progressPercent}%` }}>
          <div className="timeline-today-indicator">
            Today
          </div>
        </div>
        {hovered && (
          <div className="timeline-tooltip" style={{ left: `${progressPercent}%` }}>
            {`Progress: ${progressPercent.toFixed(1)}%`}
          </div>
        )}
      </div>
    </div>
  );
};

export default Timeline;
